/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 Radio = {
    requests: {
        open: function() {
            var html = '';

            html += '<form class="form-radio-requests">';
            html += '<div class="form-group">';
            html += '<label>Pedido</label>';
            html += '<textarea class="form-control" name="message" placeholder="Digite seu pedido"></textarea>';
            html += '</div>';
            html += '<center><button type="submit" class="form-submit">Enviar</button></center>';
            html += '</form>';

            Alertbox({
                title: "Faça seu pedido",
                content: html,
                type: 'misc'
            });
        },
        send: function(e) {
            e.preventDefault();

            var form = $(this);

            if (form.hasClass('disabled')) {
                return false;
            }

            var message = form.find('textarea[name="message"]').val();

            if (message == '') {
                form.effect('shake', { distance: 3 });
            } else {
                form.addClass('disabled').animate({'opacity': 0.5});

                $.ajax({
                    url: '/a/radio/sendRequest',
                    type: 'POST',
                    dataType: 'json',
                    data: {'message': message},
                }).done(function(data) {
                    form.removeClass('disabled').animate({'opacity': 1});

                    if (data.status == 'error') {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao fazer pedido",
                            content: message,
                            type: 'error'
                        });
                    } else {
                        $.fancybox.close();

                        Alertbox({
                            title: 'Enviado com sucesso!',
                            content: "Seu pedido foi enviado ao locutor online.",
                            type: 'success'
                        });
                    }
                });
            }
        }
    },
    presence: {
        open: function() {
            var html = '';

            html += '<form class="form-radio-presence">';
            html += '<div class="form-group">';
            html += '<label>Código de presença</label>';
            html += '<input type="text" class="form-control" name="code" placeholder="Digite o código de presença">';
            html += '</div>';
            html += '<center><button type="submit" class="btn btn-primary btn-warning">Enviar</button></center>';
            html += '</form>';

            Alertbox({
                title: "Marcar presença na programação",
                content: html,
                type: 'misc'
            });
        },
        send: function(e) {
            e.preventDefault();

            var form = $(this);

            if (form.hasClass('disabled')) {
                return false;
            }

            var code = form.find('input[name="code"]').val();

            if (code == '') {
                form.effect('shake', { distance: 3 });
            } else {
                form.addClass('disabled').animate({'opacity': 0.5});

                $.ajax({
                    url: '/a/radio/sendPresence',
                    type: 'POST',
                    dataType: 'json',
                    data: {'code': code},
                }).done(function(data) {
                    form.removeClass('disabled').animate({'opacity': 1});

                    if (data.status == 'error') {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao gerar código de presença",
                            content: message,
                            type: 'error'
                        });
                    } else {
                        $.fancybox.close();

                        Alertbox({
                            title: 'Enviado com sucesso!',
                            content: "Sua presença foi marcada com sucesso.",
                            type: 'success'
                        });
                    }
                });
            }
        }
    },
    like: function() {
        $.ajax({
            url: '/a/radio/like',
            type: 'POST',
            dataType: 'json'
        }).done(function(data) {
            if (data.status == 'error') {
                var message = "";

                for (i = data.messages.length - 1; i >= 0; i--) {
                    message += data.messages[i];

                    if (i > 0) {
                        message += '<br>';
                    }
                }

                Alertbox({
                    title: "Erro ao dar like",
                    content: message,
                    type: 'error'
                });
            } else {
                Alertbox({
                    title: 'Voto computado!',
                    content: "Seu voto para este locutor foi computado com sucesso.",
                    type: 'success'
                });
            }
        });
    },
    control: function() {
        if ($(".radio-control").data('status') == 'playing') {
            $(".radio-control").data('status', 'paused').html('<i class="far fa-play-circle"></i>');

            if (window.parent.playerFrame) {
                window.parent.playerFrame.pause();
            } else {
                document.getElementById("stream-site").pause();
            }

            Cookies.set('radio_player', 'paused');
        } else {
            if (window.parent.playerFrame) {
                window.parent.playerFrame.play();
            } else {
                var promise = document.getElementById("stream-site").play();

                if (promise !== undefined) {
                    promise.then(_ => {
                        console.log("[Stream-Site] Play successful");
                    }).catch(error => {
                        console.log("[Stream-Site] Play failed", error);
                    });
                }
            }

            $(".radio-control").data('status', 'playing').html('<i class="far fa-pause-circle"></i>');
            Cookies.set('radio_player', 'playing');
        }
    },
    initDom: function() {
        $(".radio-open-requests").on('click', Radio.requests.open);
        $(document).on('submit', '.form-radio-requests', Radio.requests.send);

        $(".radio-open-presence").on('click', Radio.presence.open);
        $(document).on('submit', '.form-radio-presence', Radio.presence.send);

        $(".radio-like").on('click', Radio.like);

        if (!window.parent.playerFrame || localStorage.getItem('radio_play') == 'not_allowed' || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            $(".radio-control").data('status', 'paused').html('<i class="far fa-play-circle"></i>');
        }

        $(".radio-control").on('click', Radio.control);
    },
    initSocket: function() {
        Sockets.socket.on("shoutcast-data", function(data) {
            if (data.id3) {
                $(".radio-info-album-art").css('background-image', 'url(' + data.id3.artwork + ')');
                $(".radio-info-music").text(data.id3.artist + ' - ' + data.id3.track);
            } else {
                $(".radio-info-album-art").attr('style', '');
                $(".radio-info-music").text(data.music);
            }

            $(".radio-info-avatar").css('background-image', 'url(' + data.broadcasterData.avatar + ');');
            $(".radio-info-broadcaster").text(data.broadcaster);
            $(".radio-info-program").text(data.program);
            $(".radio-info-listeners").text(data.listeners);

            var hideSocial = 0;

            if (data.broadcasterData && data.broadcasterData.facebook_link != '') {
                $(".radio-info-facebook").fadeIn().attr('href', data.broadcasterData.facebook_link);
            } else {
                $(".radio-info-facebook").fadeOut().attr('href', '#');
                hideSocial++;
            }

            if (data.broadcasterData && data.broadcasterData.twitter_link != '') {
                $(".radio-info-twitter").fadeIn().attr('href', data.broadcasterData.twitter_link);
            } else {
                $(".radio-info-twitter").fadeOut().attr('href', '#');
                hideSocial++;
            }

            if (data.broadcasterData && data.broadcasterData.skype_link != '') {
                $(".radio-info-skype").fadeIn().attr('href', data.broadcasterData.skype_link);
            } else {
                $(".radio-info-skype").fadeOut().attr('href', '#');
                hideSocial++;
            }

            if (data.broadcasterData && data.broadcasterData.discord_link != '') {
                $(".radio-info-discord").fadeIn().attr('href', data.broadcasterData.discord_link);
            } else {
                $(".radio-info-discord").fadeOut().attr('href', '#');
                hideSocial++;
            }

            if (data.broadcasterData && data.broadcasterData.habbo_link != '') {
                $(".radio-info-habbo-link").fadeIn().attr('href', data.broadcasterData.habbo_link);
            } else {
                $(".radio-info-habbo-link").fadeOut().attr('href', '#');
                hideSocial++;
            }

            if (hideSocial == 5) {
                $(".radio-social-media").fadeOut();
            } else {
                $(".radio-social-media").fadeIn();
            }
        });
    }
};

$(document).ready(function() {
    Radio.initDom();
});

$(window).on('connected-to-socket', function () {
    Radio.initSocket();
});
